import {
  ADD_ITEM_DETAIL,
  EDIT_ITEM_DETAIL,
  DELETE_ITEM_DETAIL,
  SELECT_ITEM_DETAIL,
  CLEAR_ITEM_DETAILS,
  LABEL_CREATE_SUCCESS,
  LOGOUT_SUCCESS,
} from "../../constants/types";

const INITIAL_STATE = {
  items: [],
  selectedItem: -1,
};

export function itemDetailsReducer(state = INITIAL_STATE, action) {
  const items = [...state.items];
  switch (action.type) {
    case ADD_ITEM_DETAIL:
      items.push(action.payload);
      return { ...state, items };
    case EDIT_ITEM_DETAIL:
      items[action.payload.itemIdx] = action.payload.item;
      return { ...state, items };
    case DELETE_ITEM_DETAIL:
      items.splice(action.payload, 1);
      return { ...state, items };
    case SELECT_ITEM_DETAIL:
      return { ...state, selectedItem: action.payload };
    case CLEAR_ITEM_DETAILS:
    case LABEL_CREATE_SUCCESS:
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    default:
      return state;
  }
}
